export default {
    props: ['id', 'data', 'field', 'url'],

    data() {
        return {
            value: this.data,
            fieldName: this.field,
            isEdit: false,
            isClean: true,
            statusClass: 'w-full h-full'
        }
    },

    watch: {
        data(newValue) {
            this.value = newValue
        }
    },

    computed: {
        classes() {
            return this.statusClass;
        }
    },

    methods: {
        toggle() {
            this.isEdit = !this.isEdit;
            this.statusClass = 'w-full h-full';
        },

        onChange() {
            this.isClean = false;
        },

        reverseDate(date) {
            return date.split('-').reverse().join('-')
        },

        onBlur(isDate) {

            if (this.isClean) {
                this.toggle();
                return;
            }

            let data = {};

            isDate ? data[this.field] = this.reverseDate(this.value) : data[this.field] = this.value;

            this.persist(data);
        },

        persist(data) {
            axios.patch(this.url + this.id, data)
                .then(() => {
                    this.toggle();
                    this.statusClass = 'w-full h-full px-3 bg-green-400 text-white';
                    this.$emit('data-has-changed', data);
        })
        .catch(() => {
                this.statusClass = 'w-full h-full border border-red text-red'
        });
        }
    }
}